<template>
  <card class="signup">
    <div class="card-header">
      <h5>{{ $t('Registration') }}</h5>
    </div>
    <div class="card-body">
      <el-form ref="registrationForm" :model="credentials" :rules="rules" status-icon @validate="updateIsFormValidating" @submit.native.prevent="register">
        <el-form-item>
          <el-radio-group v-model="personType" size="medium" @change="changePersonType">
            <el-radio-button :label="2">{{ $t('Physical person') }}</el-radio-button>
            <el-radio-button :label="1">{{ $t('Legal person') }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('Company name')" v-if="isLegalEntity" prop="organization" key="organization">
          <el-input v-model="credentials.organization"></el-input>
        </el-form-item>
        <el-form-item :label="isIndividualPerson ? $t('Name') : $t('Contact name')" prop="firstname">
          <el-input v-model="credentials.firstname"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Last name')" v-if="isIndividualPerson" prop="lastname" key="lastname">
          <el-input v-model="credentials.lastname"></el-input>
        </el-form-item>
        <el-form-item label="E-mail" prop="email">
          <el-input v-model="credentials.email"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Phone')" prop="mobile">
          <el-input id="mobile" v-model="credentials.mobile"></el-input>
        </el-form-item>
        <el-form-item prop="agreed">
            <el-checkbox v-model="credentials.agreed">
              {{ this.$t('I agree')}} <a :href='this.policy.link' target="blank">{{ this.policy.text }}</a>
            </el-checkbox>
        </el-form-item>
        <n-button
          v-loading="loading"
          type="primary"
          nativeType="submit"
          round=""
          wide=""
          :disabled="!isFormValidated"
        >
          {{ $t('Sign Up') }}
        </n-button>
      </el-form>
    </div>
  </card>
</template>

<script>
// import { FormGroupInput as FgInput, Radio, Button } from '@/ui'
import { Button } from '@/ui'
import { Form, FormItem, RadioButton, Radio, RadioGroup, Input, Checkbox } from 'element-ui'
import { mapState } from 'vuex'
import axios from 'axios'
import Inputmask from 'inputmask'
import { isEqual } from 'lodash'

export default {
  name: 'Reg',
  components: {
    [Button.name]: Button,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-radio-button': RadioButton,
    'el-radio-group': RadioGroup,
    'el-input': Input,
    'el-checkbox': Checkbox,
    'el-radio': Radio
  },
  data () {
    return {
      credentials: {
        firstname: '',
        lastname: '',
        organization: '',
        email: '',
        agreed: false,
        mobile: ''
      },
      personType: 2,
      isFormValidated: false,
      loading: false,
      rules: {
        firstname: [
          { required: true, message: this.$t('Please input first name'), trigger: 'change' }
        ],
        lastname: [
          { required: true, message: this.$t('Please input surname'), trigger: 'change' }
        ],
        organization: [
          { required: true, message: this.$t('Please input organization name'), trigger: 'change' }
        ],
        email: [
          { required: true, message: this.$t('Please input E-mail'), validator: this.validateEmail, trigger: 'change' }
        ],
        mobile: [
          { required: true, message: this.$t('Please input the phone'), validator: this.validatePhone, trigger: 'change' }
        ],
        agreed: [
          { required: true, pattern: /^(true)$/, message: this.$t('Please accept terms and conditions'), trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.cbId = Math.random().toString(16).slice(2)
  },
  mounted () {
    var im = new Inputmask(this.phoneMask)
    im.mask(document.getElementById('mobile'))
  },
  computed: {
    ...mapState({
      phoneMask: state => state.config.data.phoneMask,
      policy: state => state.config.data.policy
    }),
    isIndividualPerson: function() {
      return this.personType === 2
    },
    isLegalEntity: function() {
      return this.personType === 1
    }
  },
  methods: {
    updateIsFormValidating() {
      let fields = this.$refs.registrationForm.fields
      if (fields.find((f) => f.validateState === 'validating')) {
        setTimeout(() => { this.updateIsFormValidated() }, 100)
      } else {
        this.isFormValidated = fields.reduce((acc, f) => {
          let valid = (f.isRequired && f.validateState === 'success')
          let notErroring = (!f.isRequired && f.validateState !== 'error')
          return acc && (valid || notErroring)
        }, true)
      }
    },
    register (event) {
      this.$refs.registrationForm.validate(valid => {
        if (valid) {
          this.loading = true
          axios.post('registration/create', { ...this.credentials, type: this.personType }).then(promise => {
            this.loading = false
            this.$router.push({
              name: 'Confirm',
              params: {
                uid: promise.data.results
              }
            })
          }).catch(error => {
            this.loading = false
            this.$notify(
              {
                message: error.response.data.error,
                horizontalAlign: 'center',
                verticalAlign: 'top',
                type: 'danger'
              })
          })
        }
      })
    },
    changePersonType() {
      this.resetForm()
      this.focusFirstInput()
    },
    focusFirstInput() {
      this.$refs.registrationForm.$el.children[1].children[1].children[0].children[0].focus()
    },
    resetForm() {
      if (!isEqual(this.$data.credentials, this.$options.data().credentials)) {
        Object.assign(this.$data.credentials, this.$options.data().credentials)
      }
      this.$nextTick(function() {
        this.$refs.registrationForm.clearValidate()
      })
    },
    validatePhone(rule, value, callback, source, options) {
      const clearInput = value.replace(/\D/g, '')
      const clearedMask = this.phoneMask.replace(/\D/g, '')
      if (!clearInput || clearInput.length !== clearedMask.length) {
        callback(new Error(this.$t('Please input the phone')))
      } else {
        callback()
      }
    },
    validateEmail(rule, value, callback, source, options) {
      const emailSplit = value.split('@')
      if (value && emailSplit.length === 2 && emailSplit[0] !== '' && emailSplit[1] !== '') {
        callback()
      } else {
        callback(new Error(this.$t('Please input E-mail')))
      }
    }
  }
}

</script>

<style lang="scss" scoped>
  .signup {
    max-width: 450px;
  }
  .person-type {
    margin-bottom: 10px;
  }
  button[type=submit] {
    display: block;
    margin-top: 40px;
    margin-left: auto;
    margin-right: auto;
  }
  .el-checkbox {
    display: flex;
    align-items: center;
    a {
      white-space: normal;
    }
  }
</style>
